/**
 * Grand Quack Auto — duckling trail buffer.
 *
 * Distance-gated path sampling: mother only writes a new sample when she has
 * moved a full DUCKLING.lineSpacing from the last sample. Duckling N targets
 * the Nth step back along the path. When mother stops, the path freezes and
 * ducklings hold their formation behind her (no merge-into-mother).
 */

import { DUCKLING } from '../config';

export interface PathPoint { x: number; z: number; yaw: number; }

const pathPoints: PathPoint[] = []; // index 0 = newest (closest behind mother)
const PATH_MAX = DUCKLING.maxBrood + 4;
const PATH_STEP_SQ = DUCKLING.lineSpacing * DUCKLING.lineSpacing;

/** Returns the Nth step back along the trail, or undefined if mother hasn't walked far enough yet. */
export function getPathPoint(index: number): PathPoint | undefined {
  return pathPoints[index];
}

/** Mother calls this each tick; we only push a new sample when she's moved a full lineSpacing. */
export function maybeAddPathPoint(x: number, z: number, yaw: number): void {
  const head = pathPoints[0];
  if (head) {
    const dx = x - head.x, dz = z - head.z;
    if (dx * dx + dz * dz < PATH_STEP_SQ) return;
  }
  pathPoints.unshift({ x, z, yaw });
  if (pathPoints.length > PATH_MAX) pathPoints.pop();
}
